import {  FaExclamationTriangle, FaClock, FaTags } from "react-icons/fa"; 
import { RiCapsuleFill } from "react-icons/ri";
import PescriptionList from "./PescriptionList";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";
import { FiSearch, FiX } from "react-icons/fi";
import BillingViewFilters from "../../BillingFilterJSON";
import DefaultPatientFilters from "../ClinicComponent/Filters/DefaultPatientFilters";

const PharmacyPescription = () => {
  const navigate = useNavigate();
  const pharmacystyles = `
  .pharmacy-container {
    margin: 0 auto;   
    padding: 10px;
    height: 100%;    
  }

  h1 {
    margin-bottom: 4px;
    font-size: 1.3rem;
  }

  .subtitle {
    color: #666;
    font-size: 1rem;
  }

  .header-1 {
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom: 20px;
  }

  .gradient-button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  /* Stats Panel */
  .stats-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 18px;
    margin-bottom: 24px;
  }

  .stat-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 14px rgba(0,0,0,0.06);
    padding: 20px;
    transition: 0.3s;
    position: relative;
    overflow: hidden;
  }

  .stat-card::after {
    content: "";
    position: absolute;
    top: -40px;
    right: -40px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    opacity: 0.15;
  }

  .stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  }

  .stat-icon {
    font-size: 2.2rem;
    margin-bottom: 12px;
  }

  .stat-title {
    color: #555;
    font-size: 1rem;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .stat-value {
    font-size: 1.2rem;
    font-weight: 700;
    color: #111;
  }

  .stat-sub {
    color: #777;
    font-size: 0.95rem;
    margin-top: 6px;
  }

  @media (max-width: 600px) {
    .pharmacy-container {
      padding: 8px;
    }
    .stat-card {
      padding: 15px;
    }
    .stat-value {
      font-size: 1.8rem;
    }
  }
  `;

  const [patientDetail, setPatientDetail] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [hasData, setHasData] = useState(true);

 const appointmentData = [
  {
    id: 1,
    medicineName: "Paracetamol",
    Category: "General Medicine",
    date: "2025-08-20",
    stock: "50 strips",
    status: "Available",
    drName: "Dr. John Doe",
  },
  {
    id: 2,
    medicineName: "Amoxicillin",
    Category: "Antibiotics",
    date: "2025-08-18",
    stock: "20 bottles",
    status: "LowStock",
    drName: "Dr. Jane Smith",
  },
  {
    id: 3,
    medicineName: "Ibuprofen",
    Category: "Pain Relief",
    date: "2025-08-10",
    stock: "Out of Stock",
    status: "Unavailable",
    drName: "Dr. Alice Johnson",
  },
  {
    id: 4,
    medicineName: "Cetirizine",
    Category: "Allergy",
    date: "2025-08-25",
    stock: "80 strips",
    status: "Available",
    drName: "Dr. Alice Johnson",
  },
  {
    id: 5,
    medicineName: "Metformin",
    Category: "Diabetes",
    date: "2025-08-22",
    stock: "30 bottles",
    status: "Available",
    drName: "Dr. Bob Smith",
  },
];
  const stats = [
    {
      title: "Total Medicines",
      value: "1,248",
      sub: "+24 added this month",
      color: "#4CAF50",
      icon: <RiCapsuleFill className="stat-icon" style={{ color: "#4CAF50" }} />,
    },
    {
      title: "Low Stock Items",
      value: "42",
      sub: "Need reordering soon",
      color: "#FF9800", 
      icon: (
        <FaExclamationTriangle
          className="stat-icon"
          style={{ color: "#FF9800" }}
        />
      ),
    },
    {
      title: "Expiring Soon",
      value: "18",
      sub: "Within next 30 days",
      color: "#F44336", 
      icon: <FaClock className="stat-icon" style={{ color: "#F44336" }} />,
    },
    {
      title: "Categories",
      value: "36",
      sub: "Medicine categories",
      color: "#2196F3", 
      icon: <FaTags className="stat-icon" style={{ color: "#2196F3" }} />,
    },
  ];

    const handleClearSearch = () => {
  setPatientDetail("");
  setSelectedFilters((prev) => {
    const { fullName, patientIDUniqueID, ...rest } = prev;
    return rest;
  });
  setHasData(true);
};

  return (
    <>
      <style>{pharmacystyles}</style>
      <div className="pharmacy-container">
        {/* Header */}
                <div className="col-12 d-flex justify-content-between align-items-center mb-5"
                    style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}>
                  <div>
                    <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Pharmacy Prescription</h2>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                                <label className="relative">
                                  <input
                                    type="text"
                                    className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                                    placeholder="Enter patient name or ID"
                                    value={patientDetail}
                                  />
                                  {patientDetail && (
                                    <span
                                      className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                                      onClick={handleClearSearch}
                                    >
                                      <FiX size={16} />
                                    </span>
                                  )}
                                  <span
                                    className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                                  >
                                    <FiSearch size={16} />
                                  </span>
                                </label>
                  
                                
                  
                                <Whisper
                                  placement="top"
                                  trigger="hover"
                                  speaker={<Tooltip>Filter Options</Tooltip>}
                                >
                                  <DefaultPatientFilters
                                    defaultFilters={BillingViewFilters.default}
                                    additionalFilters={BillingViewFilters.additional}
                                    selectedFilters={selectedFilters}
                                    setSelectedFilters={setSelectedFilters}
                                    setHasData={setHasData}
                                  />
                                </Whisper>
                                <button onClick={()=>navigate("/AddPharmacyUser")} className="gradient-button">+ Add New Prescription</button>
                              </div>
        
                </div>
        <div className="flex flex-col gap-3 h-[88%]">
        <div className="h-full">
           <PescriptionList
            data={appointmentData}
          />
          </div>
          </div>
        {/* <PharmacyComponent /> */}
      </div>
    </>
  );
};

export default PharmacyPescription;
